export const HEAD_META = () =>
  `
    customHeadMeta{
      url
      ogImage
      twitterImage
      seoTitle
      seoDescription
      seoRobots
    }
`;
